/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FilePropsDto } from '../../models/file-props-dto';
import { PlayByPlayModelDto } from '../../models/play-by-play-model-dto';

export interface GameTrackerControllerUploadGamePbpCut$Params {
  uuid: string;
  pbpUuid: string;
      body: FilePropsDto
}

export function gameTrackerControllerUploadGamePbpCut(http: HttpClient, rootUrl: string, params: GameTrackerControllerUploadGamePbpCut$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayByPlayModelDto>> {
  const rb = new RequestBuilder(rootUrl, gameTrackerControllerUploadGamePbpCut.PATH, 'post');
  if (params) {
    rb.path('uuid', params.uuid, {});
    rb.path('pbpUuid', params.pbpUuid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlayByPlayModelDto>;
    })
  );
}

gameTrackerControllerUploadGamePbpCut.PATH = '/game-tracker/games/{uuid}/pbp/{pbpUuid}/upload-cut';
